import React from "react";
// styles
import styles from "./styles.module.scss";
// services
import DatePicker from "react-datepicker";
import { AiOutlineCalendar } from "react-icons/ai";
import { MdOutlineAccessTime } from "react-icons/md";

const CommonDatePicker = ({
  onChange,
  placeholder = "Select here",
  value,
  selected,
  clientDatePicker,
  maxDate,
  minDate,
  dateFormat = "dd/MM/yyyy",
  isClearable = false,
  id = "datepicker",
  showTimeSelect,
  showTimeSelectOnly,
  disabled,
  isTimer = false,
  inputError = false,
  timeFormat,
}) => {
  const handleIconClick = () => {
    const element = document.getElementById(id);
    if (element) {
      element.click();
    }
  };

  let selectedDate;
  if (isTimer) {
    selectedDate = null;
  } else {
    selectedDate = value ? new Date(value) : null;
  }

  return (
    <div
      className={`${styles.datePicker} ${inputError ? styles.inputError : " "}`}
    >
      <DatePicker
        id={id}
        placeholderText={placeholder}
        onChange={onChange}
        value={value}
        isClearable={isClearable}
        selected={selectedDate}
        maxDate={maxDate}
        minDate={minDate}
        dateFormat={dateFormat}
        showTimeSelect={isTimer}
        showTimeSelectOnly={isTimer}
        timeFormat={isTimer ? timeFormat : "HH:mm"}
        timeIntervals={15}
        autoComplete="off"
        disabled={disabled}
        showYearDropdown
        yearDropdownItemNumber={100}
        scrollableYearDropdown
        showMonthDropdown
        scrollableMonthYearDropdown
      />
      <span className={styles.icon} onClick={handleIconClick}>
        {isTimer ? (
          <MdOutlineAccessTime size={25} color="#d9d9d9" />
        ) : (
          <AiOutlineCalendar size={25} color="#d9d9d9" />
        )}
      </span>
    </div>
  );
};

export default CommonDatePicker;
